import React from "react";
import { CheckIcon } from "@heroicons/react/solid";

import EasyTrans from "../bundel/EasyTrans";
import { Button } from "../ui";

function Feature({ children }) {
  return (
    <li className="flex items-start gap-2 text-sm text-gray-600">
      <CheckIcon
        className="mt-0.5 h-5 w-5 flex-shrink-0 text-fairdarkgreen"
        aria-hidden="true"
      />
      <span>{children}</span>
    </li>
  );
}

const PriceCard = (props) => {
  const isFree = Number(props.price) === 0;
  const popular = !!props.popular;

  return (
    <div
      className={`relative mx-auto flex w-full max-w-lg flex-col rounded-2xl bg-white p-6 transition hover:-translate-y-1 hover:shadow-xl sm:p-8 lg:max-w-sm ${
        popular
          ? "shadow-xl ring-2 ring-fairblue-500"
          : "border border-gray-200 shadow-md"
      }`}
    >
      {popular && (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-fairblue-500 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-white shadow-sm">
          <EasyTrans>Landingpage.PriceCards.Popular</EasyTrans>
        </span>
      )}

      <h5 className="text-lg font-semibold text-gray-900">
        <EasyTrans>{props.nameLangKey}</EasyTrans>
      </h5>

      <div className="mt-4 flex items-baseline text-gray-900">
        <span className="text-2xl font-semibold">€</span>
        <span className="text-4xl font-extrabold tracking-tight">
          {props.price}
        </span>
        {!isFree && (
          <span className="ml-1 text-sm font-normal text-gray-500">
            / <EasyTrans>Landingpage.Year</EasyTrans> (
            <EasyTrans>Landingpage.MWST</EasyTrans>)
          </span>
        )}
      </div>

      <ul className="mt-6 space-y-3 border-t border-gray-100 pt-5">
        <Feature>
          <span className="font-medium text-gray-900">{props.storage}</span>{" "}
          <EasyTrans>Landingpage.PriceCards.Storage</EasyTrans>
        </Feature>
        <Feature>
          <EasyTrans>Landingpage.PriceCards.FeatureCertificate</EasyTrans>
        </Feature>
        <Feature>
          <EasyTrans>Landingpage.PriceCards.FeatureVisibility</EasyTrans>
        </Feature>
        <Feature>
          <EasyTrans>Landingpage.PriceCards.FeatureStorageOptions</EasyTrans>
        </Feature>
      </ul>

      <a href={props.goto} className="mt-auto block pt-7">
        <Button
          variant={popular ? "primary" : "outline"}
          size="lg"
          fullWidth
          onClick={props.onClick}
        >
          {isFree ? (
            <EasyTrans>Landingpage.LandingpageButton1</EasyTrans>
          ) : (
            <>Shop</>
          )}
        </Button>
      </a>
    </div>
  );
};

export default PriceCard;
